export const LAST_UPDATE_DATE_FORMAT = 'MM/dd/yyyy hh:mm aa';
